

import React, { Component } from 'react';

import cx from 'classnames';
import _memoize from 'lodash.memoize';
import RadioButton from './RadioButton';
import RADIO_GROUP from '../styles/radioGroup';

const NON_RADIO_CHILDREN_ERR = 'All children of RadioGroup must be of type RadioButton.';

















function checkRadioButtonChildren(children) {
  if (Array.isArray(children)) {
    children.forEach((child) => {
      if (child.type !== RadioButton) {
        throw new Error(NON_RADIO_CHILDREN_ERR);
      }
    });

    return;
  }

  if (!children || children.type !== RadioButton) {
    throw new Error(NON_RADIO_CHILDREN_ERR);
  }
}

export default class RadioGroup extends Component {
  constructor(props) {
    super(props);

    checkRadioButtonChildren(props.children);

    this.state = {
      selectedIndexes: []
    };
  }

  onSelectRadio = _memoize((index) => () => {
    const { onlyOneSelected, onChange, children, disabled } = this.props;
    const { selectedIndexes } = this.state;

    if (disabled) {return;}

    if (onlyOneSelected && selectedIndexes.length && selectedIndexes[0] === index) {return;}

    // $FlowFixMe
    const { value } = !Array.isArray(children) ? children.props : children[index].props;

    if (onlyOneSelected) {
      onChange({ value });

      return void this.setState({ selectedIndexes: [index] });
    }

    if (!selectedIndexes.includes(index)) {
      const newIndexes = [...selectedIndexes, index];

      onChange({
        selected: true,
        allItemsSelected: !children.length || newIndexes.length === children.length,
        value
      });

      return void this.setState({ selectedIndexes: newIndexes });
    }

    const arrayIndex = selectedIndexes.findIndex((selectedIndex) => selectedIndex === index);
    const newSelectedIndexes = [...selectedIndexes];

    newSelectedIndexes.splice(arrayIndex, 1);

    onChange({ selected: false, allItemsSelected: false, value });

    this.setState({ selectedIndexes: newSelectedIndexes });
  });

  addPropsToRadioButton = (button, index) => {
    const { disabled, darkMode } = this.props;
    const { selectedIndexes } = this.state;

    return React.cloneElement(
      button,
      {
        selected: selectedIndexes.includes(index),
        onChange: this.onSelectRadio(index),
        disabled,
        darkMode
      }
    );
  };

  addPropsToRadioButtons = () => {
    const { children } = this.props;

    if (!Array.isArray(children)) {
      return this.addPropsToRadioButton(children, 0);
    }

    return children.map(this.addPropsToRadioButton);
  };

  render() {
    return (
      <div className={cx(RADIO_GROUP, 'radio-group')}>
        {this.addPropsToRadioButtons()}
      </div>);

  }
}